import { Col, Row, Statistic } from 'antd';
import { useGetDonorQuery, useGetDonorStatsLazyQuery } from 'gql/types';
import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { getTranslation } from 'utils/getTranslation';

const t = getTranslation('donor.DonorStatsPanel');

const DonorStatsPanel: FC = () => {
  const params = useParams();
  const shortDonorId = params.id || '';

  const [getDonorStats, donorStatsQuery] = useGetDonorStatsLazyQuery();

  useGetDonorQuery({
    variables: { input: { id: shortDonorId } },
    onCompleted: ({ getDonor }) => {
      if (getDonor.id) {
        getDonorStats({ variables: { input: { donorId: getDonor.id } } });
      }
    },
  });

  const stats = donorStatsQuery.data?.getDonorStats;

  return (
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Statistic
          title={t('totalMlsDonated')}
          value={stats?.totalMlsDonated ?? '-'}
          suffix={stats != null ? 'mL' : undefined}
        />
      </Col>
      <Col span={12}>
        <Statistic
          title={t('totalDonations')}
          value={stats?.totalDonations ?? '-'}
        />
      </Col>
      <Col span={12}>
        <Statistic title={t('prbcCreated')} value={stats?.prbcCreated ?? '-'} />
      </Col>
      <Col span={12}>
        <Statistic
          title={t('ffpUnitsCreated')}
          value={stats?.ffpUnitsCreated ?? '-'}
        />
      </Col>
    </Row>
  );
};

export default DonorStatsPanel;
